<script>
  import { ColorPicker, Color } from "svelte-colorpick";
  import { onMount } from "svelte";
  import { gun } from "../gun.js";
  import { selectedAccount, connected } from "svelte-web3";
  import EditorLog from "../components/EditorLog.svelte";
  import Header from "../components/Header.svelte";
  import Footer from "../components/Footer.svelte";
  import md5 from "blueimp-md5";

  const urlParams = new URLSearchParams(window.location.search);
  const urlKey = md5(urlParams.get("key"));
  let allEditors = false;
  let m = { x: 0, y: 0 };
  let canvas;
  let sessionLogged = false;
  let mousedown = false;

  let colorHistory = ["#ffffff"];
  var randomColor = Math.floor(Math.random() * 16777215).toString(16);
  let color = Color.hex("#" + randomColor);
  let collapseColor = true;
  let date = new Date();
  let tomorrow = new Date(date);
  let yesterday = new Date(date);
  tomorrow.setDate(tomorrow.getDate() + 1);
  yesterday.setDate(yesterday.getDate() - 1);
  let todayUTC = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  let tomorrowUTC = Date.UTC(
    tomorrow.getFullYear(),
    tomorrow.getMonth(),
    tomorrow.getDate()
  );
  let yesterdayUTC = Date.UTC(
    yesterday.getFullYear(),
    yesterday.getMonth(),
    yesterday.getDate()
  );
  let ttrDisplay = new Date(tomorrowUTC - new Date().getTime())
    .toISOString()
    .substr(11, 8);

  let canvasNode = "pixel-canvas-" + todayUTC;
  if (urlKey == "72ab8af56bddab33b269c5964b26620a") {
    canvasNode = "pixel-canvas-" + yesterdayUTC;
    allEditors = true;
  }
  let lastPixel;
  let lastColor;

  function handleMousemove(evt) {
    var rect = canvas.getBoundingClientRect();
    m.x = ((evt.clientX - rect.left) / (rect.right - rect.left)) * canvas.width;
    m.y = ((evt.clientY - rect.top) / (rect.bottom - rect.top)) * canvas.height;

    if (mousedown) {
      drawPoint();
    }
  }

  function handleMouseDown() {
    mousedown = true;
    drawPoint();
  }

  function handleMouseUp() {
    mousedown = false;
  }

  function pixelIdToCoords(id) {
    let x, y;
    x = Math.abs(Math.floor(id / 60));
    y = id - x * 60;
    return { x: x * 10, y: y * 10 };
  }

  function drawPoint() {
    if (!$connected) {
      alert("connect wallet first");
      return;
    }

    let xP, yP, x, y, pColor;
    let offs = 5;
    pColor = color.toHex();
    xP = Math.abs(Math.round((m.x - offs) / 10));
    yP = Math.abs(Math.round((m.y - offs) / 10));
    let pixelID = xP * 60 + yP;

    if (pixelID == lastPixel && pColor == lastColor) {
      return;
    }
    x = xP * 10;
    y = yP * 10;

    let ctx = canvas.getContext("2d");
    ctx.fillStyle = pColor;
    ctx.fillRect(x, y, 10, 10);

    pixelIdToCoords(pixelID);
    gun.get(canvasNode).get(pixelID).put({ color: pColor });
    lastPixel = pixelID;
    lastColor = pColor;
    logEditor(pixelID, pColor);
  }

  function drawRemotePoint(id, color) {
    let coords = pixelIdToCoords(id);
    if (canvas) {
      let ctx = canvas.getContext("2d");
      ctx.fillStyle = color;
      ctx.fillRect(coords.x, coords.y, 10, 10);
    }
  }

  function logEditor(id, color) {
    const index = new Date().toISOString();
    gun.get(canvasNode + "-logs").set({
      ts: new Date().toISOString(),
      acc: checkAccount,
      pid: id,
      color: color,
    });
    if (!sessionLogged) {
      sessionLogged = true;
      gun
        .get(canvasNode + "-editors")
        .get(checkAccount)
        .put({ sessionStart: new Date().toISOString() });
    }
  }

  function onPickerCollapse() {
    if (lastColor)
      colorHistory = [...colorHistory.reverse().slice(-3), lastColor].reverse();
  }

  function selectColor(e) {
    color = e.target.getAttribute("data-color");
  }

  onMount(() => {
    const interval = setInterval(() => {
      if (ttrDisplay == "00:00:02" || ttrDisplay == "00:00:01") {
        setTimeout(() => {
          window.location.reload();
        }, 4000);
      }
      ttrDisplay = new Date(tomorrowUTC - new Date().getTime())
        .toISOString()
        .substr(11, 8);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });

  gun
    .get(canvasNode)
    .map()
    .on(function (data, key) {
      if (data) {
        drawRemotePoint(key, data.color);
      }
    });

  $: canvasTitle = new Date(todayUTC).toDateString();
  $: checkAccount =
    $selectedAccount || "0x0000000000000000000000000000000000000000";
</script>

<Header />
<div id="controls" class="mb-2">
  <div class="color-container">
    <ColorPicker
      bind:color
      on:pickerCollapse={onPickerCollapse}
      background="#111827"
      collapse={collapseColor}
      selectedDimension="hcl.h"
      tabbed={false}
      showSliders={{
        "hcl.h": true,
      }}
      selectedTab="hcl"
      showMatrix={true}
      showHex={true}
      showNumeric={false}
      showLabels={false}
      selectDimensions={false}
      matrixWidth={150}
      matrixHeight={150}
      scrollbarHeight={10}
    />
    {#each colorHistory as color, i}
      <div
        class="color-history-item"
        key={i}
        data-color={color}
        style="background-color: {color}"
        on:click={selectColor}
      />
    {/each}
  </div>
  <h2 class="font-black">TIME LEFT: {ttrDisplay}</h2>
</div>
<canvas
  on:mousemove={handleMousemove}
  bind:this={canvas}
  on:mousedown={handleMouseDown}
  on:mouseup={handleMouseUp}
  on:mouseleave={handleMouseUp}
  width="600"
  height="600"
  id="pixelcanvas"
  data-id={canvasNode}
/>
<h3 class="mt-0 mb-0 font-black text-white uppercase text-right">
  {canvasTitle}
</h3>
<EditorLog {canvasNode} showAll={allEditors} />
<Footer />

<style>
  #controls {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  div {
    color: white;
  }

  canvas {
    width: 600px;
    height: 600px;
    background-color: #fff;
    max-width: 95vw;
    max-height: 95vw;
  }

  .color-container {
    display: flex;
    align-items: baseline;
    gap: 10px;
  }

  .color-history-item {
    width: 15px;
    height: 15px;
    border: 1px solid #666;
    cursor: pointer;
  }

  @media only screen and (max-height: 900px) {
    canvas {
      width: 600px;
      height: 600px;
      background-color: #fff;
      max-width: 65vh;
      max-height: 65vh;
    }
  }
</style>
